import React from 'react'
import styles from './AppPrimaryBtn.module.css'

interface ButtonProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  ariaLabel?: string
  ariaDescribedby?: string
  ariaExpanded?: boolean
  ariaPressed?: boolean
  ariaHaspopup?: boolean | 'menu' | 'dialog' | 'listbox' | 'tree' | 'grid'
  tabIndex?: number
  role?: string
  disabled?: boolean
}

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  onClick,
  ariaLabel,
  ariaDescribedby,
  ariaExpanded,
  ariaPressed,
  ariaHaspopup,
  tabIndex,
  role,
  disabled
}) => {
  return (
    <button
      className={`${styles.primary} ${className || ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
      aria-expanded={ariaExpanded}
      aria-pressed={ariaPressed}
      aria-haspopup={ariaHaspopup}
      tabIndex={tabIndex}
      role={role}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default Button
